import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { APIUserService } from '../@core/utils/user.service';


@Injectable()
export class AdminGuard implements CanActivate {
  constructor(private router : Router, private userService: APIUserService){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):  Observable<boolean> {
      return this.userService.isAdmin.pipe(take(1), map(isAdmin => {
            if(!isAdmin)
                this.router.navigateByUrl('/auth/signin');
            return isAdmin
        }))
  }
}